import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const sshSecurityInfoTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'SSH Security Info',
  key: 'sshSecurityInfo',
  main: {
    metadata: {
      layout: {
        rows: [
          ['SS8ID', 'SSHTYPE', 'AUTHTYPE'],
          ['USERNAME', 'PASSWORD', '$empty'],
          ['keysConfig', '$empty', '$empty'],
          ['PRIVKEYFILENAME', 'PASSPHRASE', 'PUBKEYFILENAME'],
          ['SSHDIR', 'HOSTKEYTYPE', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
        disabled: true
      },
      SS8ID: {
        label: 'SSH Credentials ID',
        hintMessage: 'Max 16 characters with no spaces',
        type: 'text',
        disabled: false,
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      SSHTYPE: {
        label: 'Type of Interface',
        type: 'select',
        initial: 'SERVER',
        options: [
          {
            label: 'SERVER',
            value: 'SERVER',
          },
          {
            label: 'CLIENT',
            value: 'CLIENT',
          },
        ],
      },
      AUTHTYPE: {
        label: 'Authentication Type',
        type: 'select',
        initial: 'PASSWORD',
        options: [
          {
            label: 'PASSWORD',
            value: 'PASSWORD',
          },
          {
            label: 'SSHKEYS',
            value: 'SSHKEYS',
          },
        ],
      },
      USERNAME: {
        label: 'SSH User Name',
        hintMessage: 'Max 16 characters with no spaces',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      PASSWORD: {
        label: 'SSH Password',
        type: 'password',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32,
            },
          ],
        },
      },
      PRIVKEYFILENAME: {
        label: 'Private Key File Name',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      PASSPHRASE: {
        label: 'Private Key Passphase',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
          ],
        },
      },
      PUBKEYFILENAME: {
        label: 'Public Key File Name',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
          ],
        },
      },
      SSHDIR: {
        label: 'SSH Directory',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 255,
            },
          ],
        },
      },
      HOSTKEYTYPE: {
        label: 'Host Key Type',
        type: 'select',
        initial: 'RSA',
        options: [
          {
            label: 'RSA',
            value: 'RSA',
          },
          {
            label: 'DSA',
            value: 'DSA',
          },
          {
            label: 'ECDSA',
            value: 'ECDSA',
          },
          {
            label: 'ED25519',
            value: 'ED25519',
          },
        ],
      },
      keysConfig: {
        type: 'custom',
        initial: 'Keys Configuration',
        customComponent: 'privateKey',
        className: 'section-label',
      }
    },
  },
};
